/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespDealerDetailsStats_reviews$ref = any;
export type PdpRespDealerDetailsStats_reviews = {
    readonly metadata: {
        readonly aggregatedFeedback: {
            readonly overallExperience: {
                readonly mean: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": PdpRespDealerDetailsStats_reviews$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespDealerDetailsStats_reviews",
    "type": "SellerOrderFeedbackPdpQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "metadata",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "aggregatedFeedback",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AggregatedOrderFeedbackType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "overallExperience",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AggregatedOrderFeedbackQuestionType",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mean",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'da7686425e1b933b4f9aaa2602d2ffd2';
export default node;
